import React, { useEffect, useState } from "react";
import { useSessionStorage } from "../../../hooks/useSessionStorage";
import { useBrowserSessionStorage } from "../../../hooks/useBrowserSessionStorage";
import { useLocation, useNavigate } from "react-router-dom";
import { useContextSite } from "../../../context/Context";
import { cleanStorage } from "../../../utils/cleanStorage";
import { RolesEnum } from "../../../enums/roles";
import { TipoClienteEnum } from "../../../enums/tipoCliente";
import { Usuario } from "../../../services/Usuario";
import { useUserPermissions } from "../../../hooks/useUserPermissions";

const LINKS = {
  starcheck: "https://starcheck.com.br/",
  log: "https://logvistorias.com.br/",
  vlx: "https://veloxvistorias.com.br/",
  tokyo: "https://tokyovistorias.com.br/",
};

export const useLayout = () => {
  const { hasRole, isAdmin: checkIsAdmin, isUserType } = useUserPermissions();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [usuario] = useSessionStorage("@usuarioMapa");
  const [token] = useSessionStorage("@token");
  const [, setProximaRotaAgendamento] = useBrowserSessionStorage(
    "@proximaRotaAgendamento",
  );
  const { pathname } = useLocation();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { setIsLoad } = useContextSite();
  const { setTokenContext, tokenContext } = useContextSite();
  const [resources, setResources] = useState<string[]>([]);
  const isCliente = hasRole(RolesEnum.ROLE_CLIENTE);
  const isAdmin = checkIsAdmin();
  const isVistoriador = hasRole(RolesEnum.ROLE_VISTORIADOR);
  const isCustomsBroker = isUserType(TipoClienteEnum.DESPACHANTE);

  const destinoNovoAgendamento = !isCliente
    ? "/novo-agendamento"
    : isCustomsBroker
      ? "/agendamento/inicio"
      : "/agendamento";

  React.useEffect(() => {
    if (usuario)
      Usuario.getRecursosByUuid({ uuid: usuario?.uuidUsuario })
        .then(({ data }) => {
          setResources(data);
        })
        .catch(() => console.log("erro ao buscar recursos"));
  }, [usuario]);

  function logout() {
    setIsLoad(true);
    setModalIsOpen(false);

    setTimeout(() => {
      cleanStorage();
      setTokenContext("");
      setIsLoad(false);
      navigate("/agendamento/auth");
    }, 1000);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    setMenuOpen(false);
  }, [pathname]);

  return {
    logout,
    menuOpen,
    setMenuOpen,
    token,
    modalIsOpen,
    navigate,
    setModalIsOpen,
    isCliente,
    LINKS,
    isAdmin,
    isVistoriador,
    usuario,
    destinoNovoAgendamento,
    setProximaRotaAgendamento,
  };
};
